import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import Script from 'next/script';
import '../styles/globals.css';
import { ConsentManager, gtmDataLayerScript, gtmScript, gtmNoScript } from '../utils/ConsentUtils';
import OneTapLogin from '../components/OneTapLogin';

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  
  // Инициализация dataLayer при монтировании компонента
  useEffect(() => {
    // Загрузка dataLayer скрипта
    const dataLayerScript = document.createElement('script');
    dataLayerScript.innerHTML = gtmDataLayerScript;
    document.head.appendChild(dataLayerScript);
    
    // Загрузка GTM скрипта
    const gtmScriptElement = document.createElement('script');
    gtmScriptElement.innerHTML = gtmScript;
    gtmScriptElement.onload = () => {
      console.log('✅ GTM script loaded');
    };
    document.head.appendChild(gtmScriptElement);
    
    return () => {
      // Удаляем скрипты при размонтировании компонента
      if (dataLayerScript.parentNode) {
        dataLayerScript.parentNode.removeChild(dataLayerScript);
      }
      if (gtmScriptElement.parentNode) {
        gtmScriptElement.parentNode.removeChild(gtmScriptElement);
      }
    };
  }, []);
  
  // Проверка наличия принудительного выхода
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const forceLogout = localStorage.getItem('force_logout') === 'true';
      const logoutParam = router.query.logout === 'true';
      
      if (forceLogout || logoutParam) {
        // Очищаем флаг принудительного выхода
        localStorage.removeItem('force_logout');
        
        // Очищаем все токены и данные авторизации
        try {
          localStorage.removeItem('auth_action');
          localStorage.removeItem('user-storage');
          sessionStorage.removeItem('backend_verified');
          
          // Очищаем куки авторизации
          const cookiesToClear = ['jwt_access_token', 'jwt_refresh_token', 'auth_token', 'firebase_token'];
          cookiesToClear.forEach(name => {
            document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
          });
        } catch (e) {
          console.error('Error clearing auth data:', e);
        }
      }
    }
  }, [router.query]);

  return (
    <>
      <Head>
        <title>My App</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      
      <Component {...pageProps} />
      
      {/* Google One Tap Login компонент */}
      <OneTapLogin />
      
      {/* GTM noscript tag */}
      <noscript dangerouslySetInnerHTML={{ __html: gtmNoScript }} />
      
      {/* Consent Management Component */}
      <ConsentManager />
    </>
  );
} 

export default MyApp;